import { api } from '@tools/ui/api';
import { Scalars, Team } from '@tools/ui/types/generated/graphql';
import { handleSuccessResponse, Response } from '@tools/ui-utils/response-handling.util';

const routePrefix = '/teams';

// TODO: REMOVE after splitting graphql unauthorized routes
export const getTeamsWithRoles = async (): Promise<Team[]> => {
  return api.get(`${routePrefix}/getAll`);
};

export const createTeam = async (team: Partial<Team>): Promise<Response> => {
  return api.post(`${routePrefix}`, team).then(handleSuccessResponse);
};

export const updateTeam = async (team: Partial<Team>): Promise<Response> => {
  return api.put(`${routePrefix}`, team).then(handleSuccessResponse);
};

export const deleteTeam = async (teamId: Scalars['MongoID']): Promise<Response> => {
  return api.delete(`${routePrefix}`, { data: { _id: teamId } }).then(handleSuccessResponse);
};
